// import patPic from "../images/crew/pat-b&w-pic.png";
// import anharPic from "../images/crew/anhar-image.jpg";
// import mattPic from "../images/crew/matt-pic.png";
// import gretchPic from "../images/crew/GScottHeadShotB&W.png";

const testimonialList = [
	{
		name: "Chy Meng",
		currentWorkTitle: "Software Engineer",
		currentWorkplace: "Culture Amp",
		testimonialContent:
			"Matt was a fantastic educator during my time at Coder Academy. He was knowledgeable, patient and empathetic when seeking assistance and could communicate complex concepts in simple terms.",
	},
	{
		name: "Serina Ko",
		currentWorkTitle: "Software Engineer",
		currentWorkplace: "MYOB",
		testimonialContent:
			"Back when I was learning to code, Matt taught me the ropes and provided me with invaluable support. He has a lot of experience in teaching and he is an enthusiastic and patient teacher. Now I have a rewarding career at MYOB. I am grateful to him for helping me out when I was taking the first steps on my coding journey.",
	},
	{
		name: "Mizuki Zenta",
		currentWorkTitle: "Software Developer",
		currentWorkplace: "Marketplacer",
		testimonialContent:
			"Matt was the most patient and kind teacher I've ever had. I couldn't have been where I am without his help.",
	},
	{
		name: "John Voon",
		currentWorkTitle: "Team Lead",
		currentWorkplace: "Marketplacer",
		testimonialContent:
			"I was very fortunate to have Matt as one of my instructors at Coder Academy and am really excited for those who will be choosing him as their instructor. You can tell he not only loves coding and knows his stuff but more importantly, has the passion and skills for teaching and mentoring. He’s super supportive, patient and caring. Also an excellent communicator, able to explain complex things in a simple way and goes the extra mile to help people. Matt not only taught me the skills I needed to kick start my career in software but also helped me enjoy the journey.",
	},
	{
		name: "Clinton Forster",
		currentWorkTitle: "Software Engineer",
		currentWorkplace: "One Two Home Loans",
		testimonialContent:
			"I tried teaching myself to code on and off for years but would always get to a point where I eventually got stuck and had no idea how to figure my way out of the issue I was facing. That was until I was taught to code face-to-face by Matt McKenzie. Matt’s patience and ability as a teacher knows no bounds and his ability to break down the most complex of concepts for people of any level is second to none. Even in a large class Matt made sure he had time for everyone and that no one was left behind.",
	},
];

function Testimonials() {
	return (
		<div className="liskov-who">
			<h2>Testimonials</h2>
			<div className="collaborator-grid">
				{testimonialList.map((testimonial) => {
					return (
						<div className="name-and-pic testimonial-area">
							<h3>{`${testimonial.name}`}</h3>
							<h4>{`${testimonial.currentWorkTitle};`}</h4>
							<h4>{`${testimonial.currentWorkplace};`}</h4>
							{/* <img src={testimonial.photoSrc} alt={testimonial.photoAlt} /> */}
							<p>{testimonial.testimonialContent}</p>
						</div>
					);
				})}
			</div>
		</div>
	);
}

export default Testimonials;
